import React, { useState } from "react";
import Header from "../../Component/Header/index";
import Footer from "../../Component/Footer";
import { Container } from "react-bootstrap";
import Section from "../../Component/Section";
import CategoryProduct from "../../Component/CategoryProduct";
import Category from "../../Component/Category";
export default function Index() {
  return (
    <Container fluid style={{ padding: "0px", margin: "0px" }}>
      <Header />
      <Section title={"Activities"} />
      <Category />
      <Footer />
    </Container>
  );
}
